import React, { PropsWithChildren, useContext } from 'react';

import { media } from 'context';
import { Animate, Layout, Text } from 'ds';
import { Color } from 'shared';

import { ReactComponent as AiAssistantIcon } from 'ds/ai-assistant.svg';

interface Props {
  color?: Color;
}

const StepTitle: React.FC<PropsWithChildren<Props>> = ({ children, color = 'purple-gradient' }) => {
  const { xs, sm } = useContext(media);
  const isMobile = xs || sm;

  return isMobile ? (
    <Animate duration={300}>
      <Text size="headline-md" color={color}>
        {children}
      </Text>
    </Animate>
  ) : (
    <Layout gap={24} align="center" flex>
      <AiAssistantIcon style={{ flexShrink: 0 }} width={72} height={72} />
      <Animate duration={300}>
        <Text size="headline-xl" color={color}>
          {children}
        </Text>
      </Animate>
    </Layout>
  );
};

export default StepTitle;
